/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Nodes} from "../Objects/Nodes.jsx";
import DisplayJson from "./DisplayJSON.jsx";

class DisplayNodeState extends Component {
    constructor() {
        super();
        this.state = {
            currentState: {}
        }
    }

    async fetchData() {
        let {nodeId} = this.props
        let result = await Nodes(nodeId).getCurrentState()
        this.setState({currentState: result?.success ? result.currentState : result})
    }

    componentDidMount() {
        this.fetchData()
        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId) {
            this.fetchData()
        }
    }


    render() {

        return (
            <div className={" w-full"}>
                <DisplayJson jsonInput={this.state.currentState}/>
            </div>
        );
    }
}

DisplayNodeState.propTypes = {};

DisplayNodeState.defaultProps = {};


export default DisplayNodeState;
